import NavBar from "../../components/main/navBar";

const Hero = () => {
  return (
    <section className="hero-section" id="hero">
      <NavBar />
      <div></div>
      <div className="color-form pink"></div>
      <div className="hero-content">
        <img
          src={require("../../assets/img/pfp.png")}
          alt=""
          style={{ height: "200px" }}
        />
        <h1>
          Hey, je suis Ilann 💫 !<br /> Innovateur digital, je transforme les
          idées en expériences uniques.
        </h1>
      </div>
      <div className="scroll-down-icon">
        <i
          class="fa-solid fa-chevron-down fa-2xl"
          style={{ color: "#ffffff" }}
        ></i>
        <i
          class="fa-solid fa-chevron-down fa-2xl"
          style={{ color: "#ffffff}" }}
        ></i>
      </div>
    </section>
  );
};

export default Hero;
